import type { EnrichedScenario } from '../model/types'

/**
 * Filters enriched scenarios by search term.
 * Case-insensitive search is performed across both scenario name and optimization group name.
 * @param search - The search term string.
 * @param scenarios - Array of enriched with optimization group names scenarios to filter. [EnrichedScenario[]]
 * @returns A filtered array of enriched with optimization group name scenarios. [EnrichedScenario[]]
 */

export const filterScenarios = (
	search: string,
	scenarios?: EnrichedScenario[]
): EnrichedScenario[] => {
	if (!scenarios) return []

	const term = search.trim().toLowerCase()
	if (!term) return scenarios

	return scenarios.filter(
		({ name, optimization_group_name }) =>
			name.toLowerCase().includes(term) ||
			(optimization_group_name?.toLowerCase().includes(term) ?? false)
	)
}
